import React, { createContext, useContext, useState, useCallback } from "react";

const CompareContext = createContext(null);
const MAX_COMPARE = 3;

export function CompareProvider({ children }) {
  const [compareList, setCompareList] = useState([]);
  const [showBar, setShowBar] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const addToCompare = useCallback((product) => {
    setCompareList(prev => {
      if (prev.find(p => p.id === product.id)) return prev;
      if (prev.length >= MAX_COMPARE) return prev;
      const next = [...prev, product];
      setShowBar(true);
      return next;
    });
  }, []);

  const removeFromCompare = useCallback((productId) => {
    setCompareList(prev => {
      const next = prev.filter(p => p.id !== productId);
      if (next.length === 0) setShowBar(false);
      return next;
    });
  }, []);

  const isInCompare = useCallback((productId) => {
    return compareList.some(p => p.id === productId);
  }, [compareList]);

  const clearCompare = useCallback(() => {
    setCompareList([]);
    setShowBar(false);
    setShowModal(false);
  }, []);

  return (
    <CompareContext.Provider value={{ compareList, addToCompare, removeFromCompare, isInCompare, clearCompare, showModal, setShowModal }}>
      {children}

      {showBar && compareList.length > 0 && !showModal && (
        <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, backgroundColor: "#1e293b", borderTop: "3px solid #0d9488", padding: "14px 24px", zIndex: 8888, display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap", boxShadow: "0 -4px 20px rgba(0,0,0,0.3)" }}>
          <div style={{ display: "flex", gap: "10px", flex: 1, flexWrap: "wrap" }}>
            {compareList.map(p => (
              <div key={p.id} style={{ display: "flex", alignItems: "center", gap: "8px", backgroundColor: "#334155", borderRadius: "8px", padding: "6px 10px" }}>
                <img src={p.image} alt={p.nom} style={{ width: "36px", height: "36px", objectFit: "cover", borderRadius: "4px" }} />
                <span style={{ fontSize: "13px", color: "#f1f5f9", fontWeight: "600", maxWidth: "120px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {p.nom}
                </span>
                <button onClick={() => removeFromCompare(p.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", padding: "0", display: "flex" }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </div>
            ))}
            {Array.from({ length: MAX_COMPARE - compareList.length }).map((_, i) => (
              <div key={"empty-" + i} style={{ width: "160px", height: "50px", border: "2px dashed #475569", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span style={{ fontSize: "12px", color: "#64748b" }}>+ Ajouter</span>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", gap: "10px", flexShrink: 0 }}>
            <span style={{ fontSize: "13px", color: "#94a3b8", alignSelf: "center" }}>
              {compareList.length}/{MAX_COMPARE} produits
            </span>
            {compareList.length >= 2 && (
              <button onClick={() => setShowModal(true)} style={{ padding: "10px 20px", backgroundColor: "#0d9488", color: "white", border: "none", borderRadius: "8px", fontSize: "14px", fontWeight: "700", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
                  <rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" />
                </svg>
                Comparer
              </button>
            )}
            <button onClick={clearCompare} style={{ padding: "10px 16px", backgroundColor: "transparent", color: "#94a3b8", border: "1px solid #475569", borderRadius: "8px", fontSize: "13px", cursor: "pointer" }}>
              Effacer
            </button>
          </div>
        </div>
      )}

      {showModal && compareList.length >= 2 && (
        <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.7)", zIndex: 9900, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "20px", overflowY: "auto" }} onClick={() => setShowModal(false)}>
          <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", width: "100%", maxWidth: "1100px", marginTop: "20px", overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>

            <div style={{ padding: "20px 24px", borderBottom: "1px solid #e5e7eb", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#f8fafc" }}>
              <h2 style={{ fontSize: "20px", fontWeight: "700", color: "#1f2937", margin: 0 }}>Comparaison de produits</h2>
              <button onClick={() => setShowModal(false)} style={{ background: "none", border: "none", cursor: "pointer", color: "#6b7280" }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "600px" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f8fafc" }}>
                    <th style={{ padding: "16px 20px", textAlign: "left", fontSize: "13px", color: "#6b7280", fontWeight: "600", width: "180px", borderBottom: "1px solid #e5e7eb" }}>
                      Critère
                    </th>
                    {compareList.map(p => (
                      <th key={p.id} style={{ padding: "16px 20px", textAlign: "center", borderBottom: "1px solid #e5e7eb", borderLeft: "1px solid #e5e7eb" }}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                          <img src={p.image} alt={p.nom} style={{ width: "80px", height: "60px", objectFit: "cover", borderRadius: "8px" }} />
                          <span style={{ fontSize: "13px", fontWeight: "700", color: "#1f2937", textAlign: "center" }}>{p.nom}</span>
                          <button onClick={() => removeFromCompare(p.id)} style={{ fontSize: "11px", color: "#dc2626", background: "none", border: "none", cursor: "pointer", padding: 0 }}>Retirer</button>
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <CompareRow label="Prix" values={compareList.map(p => ({ value: p.prix, highlight: true }))} />
                  <CompareRow label="Categorie" values={compareList.map(p => ({ value: p.categorie }))} />
                  <CompareRow label="Marque" values={compareList.map(p => ({ value: p.marque || "-" }))} />
                  <CompareRow label="Etat" values={compareList.map(p => ({ value: p.isNew ? "Neuf" : "Occasion" }))} />
                  <CompareRow label="Localisation" values={compareList.map(p => ({ value: p.localisation || "-" }))} />
                  <CompareRow label="Vues" values={compareList.map(p => ({ value: (p.vues || 0) + " vues" }))} />
                  {(() => {
                    const allKeys = new Set();
                    compareList.forEach(p => p.ficheTechnique && Object.keys(p.ficheTechnique).forEach(k => allKeys.add(k)));
                    return Array.from(allKeys).slice(0, 10).map(key => (
                      <CompareRow key={key} label={key} values={compareList.map(p => ({ value: p.ficheTechnique && p.ficheTechnique[key] ? p.ficheTechnique[key] : "-" }))} />
                    ));
                  })()}
                </tbody>
              </table>
            </div>

            <div style={{ padding: "16px 24px", borderTop: "1px solid #e5e7eb", display: "flex", gap: "12px", flexWrap: "wrap" }}>
              {compareList.map(p => (
                <a key={p.id} href={"/annonce/" + p.id} onClick={() => setShowModal(false)} style={{ flex: 1, minWidth: "120px", padding: "10px", backgroundColor: "#0d9488", color: "white", borderRadius: "8px", textDecoration: "none", textAlign: "center", fontSize: "13px", fontWeight: "600" }}>
                  Voir {p.nom.split(" ").slice(0, 2).join(" ")}
                </a>
              ))}
            </div>

          </div>
        </div>
      )}
    </CompareContext.Provider>
  );
}

function CompareRow({ label, values }) {
  return (
    <tr style={{ borderBottom: "1px solid #f3f4f6" }} onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f8fafc"} onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"}>
      <td style={{ padding: "12px 20px", fontSize: "13px", color: "#6b7280", fontWeight: "500", backgroundColor: "#fafafa", borderBottom: "1px solid #e5e7eb" }}>
        {label}
      </td>
      {values.map((v, i) => (
        <td key={i} style={{ padding: "12px 20px", textAlign: "center", fontSize: "14px", fontWeight: v.highlight ? "700" : "500", color: v.highlight ? "#0d9488" : "#1f2937", borderLeft: "1px solid #e5e7eb", borderBottom: "1px solid #e5e7eb" }}>
          {v.value}
        </td>
      ))}
    </tr>
  );
}

export const useCompare = () => useContext(CompareContext);